import React, { useEffect } from 'react';
import Card from './Card';
//import Pagination from './Pagination';
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';

function Cards(props) {
  const [page, setPage] = React.useState(1);
  const [count, setCount] = React.useState(0);
  const [companies, setCompanies] = React.useState([])
  const [paginationPerPage, setPaginationPerPage] = React.useState(10);
  const [indexOfLastItem, setIndexOfLastItem] = React.useState(page * paginationPerPage)
  const [indexOfFirstItem, setIndexOfFirstItem] = React.useState(indexOfLastItem - paginationPerPage)

  const handleChange = (event, value) => {
    setPage(value)
    filterByPage(value)
  };

  useEffect(() => {
    let pageNumber = 1
    setPage(pageNumber)
    filterByPage(pageNumber)
    setCount(Math.ceil(props.companies.length / props.paginationPerPage))
  }, [props.companies])

  
  useEffect(() => {
    let pageNumber = 1
    setPage(pageNumber)
    filterByPage(pageNumber)

    setPaginationPerPage(props.paginationPerPage)
    setCount(Math.ceil(props.companies.length / props.paginationPerPage))
  }, [props.paginationPerPage])

  const filterByPage = (page) => {
    let last  = page * props.paginationPerPage
    let first = last - props.paginationPerPage
    setCompanies(props.companies.slice(first, last))
  }

  return (
    <Stack spacing={4}>
      <div className='cards'>
        {
          companies.map((company, idx) => {
            return <Card company={company} key={idx}/>
          })
        }
      </div>
      {
        props.pending ? 'Loading...' : ''
      }
      { count > 1 ?
        <Pagination count={count} page={page} variant="outlined" shape="rounded" onChange={handleChange} />
        : count === 0 && !props.pending? 'There are no records to display' : ''
      }
    </Stack>

  );
};

export default Cards;